import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

const ThreadsEmptyView = () => {
  return (
    <Box
      py={2}
      fontSize={16}
      width="100%"
      display="flex"
      justifyContent="flex-start"
    >
      <FormattedMessage
        id="forum.empty.message"
        defaultMessage="Aún no hay posts en el foro."
      />
    </Box>
  );
};

export default ThreadsEmptyView;
